import { useState } from "react";

import { countries } from "shared/config/consts/countries";

import { Row } from "./row";
import { SearchInput } from "./search-input";

type Props = {
  onSelect: (countryCode: string) => void;
};

export const SelectCountry = (props: Props) => {
  const { onSelect } = props;
  const [input, setInput] = useState("");

  const filteredCountries = input
    ? countries.filter((c) =>
        c.name.toLowerCase().includes(input.toLowerCase())
      )
    : countries;

  return (
    <>
      <h2 className="mt-5 text-center text-2xl font-semibold whitespace-pre-line">
        {`Country of residence`}
      </h2>

      <div className="bg-whiteSmoke relative mt-5 flex w-full flex-col overflow-y-auto rounded-xl py-3">
        <SearchInput
          value={input}
          onChange={(e) => {
            setInput(e.target.value.trim());
          }}
          className="sticky top-0 mb-1 px-3"
        />
        {filteredCountries.map((country) => {
          return (
            <Row
              key={country.code}
              image={<span className="text-xl">{country.emoji}</span>}
              text={country.name}
              onClick={() => {
                onSelect(country.code);
              }}
            />
          );
        })}
      </div>
    </>
  );
};
